module.exports = __webpack_public_path__ + "img/tgh2.2fe0d5f6.jpg";